import { initializeApp } from "firebase/app";
import * as firebaseAuth from "firebase/auth";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyCHpSizrX3hXq-ZBIW_uxt8CqzS4bR_tXE",
  authDomain: "easymeet-26dd0.firebaseapp.com",
  databaseURL: "https://easymeet-26dd0-default-rtdb.firebaseio.com",
  projectId: "easymeet-26dd0",
  storageBucket: "easymeet-26dd0.appspot.com",
  messagingSenderId: "405934747567",
  appId: "1:405934747567:web:23ec246bc536219abd095a",
  measurementId: "G-DFQQZL8PRC"
};

const firebaseApp = initializeApp(firebaseConfig);
const firebaseDB = getFirestore(firebaseApp);
const firebaseGetAuth = firebaseAuth.getAuth(firebaseApp);

export {
  firebaseAuth,
  firebaseGetAuth,
  firebaseDB,
  firebaseApp,
  firebaseConfig
};